import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MemberListService } from '../../services/memberlist.service';
import { NewmemberService } from '../../services/newmember.service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { UserService } from '../../services/user.service'
import { OtpComponent } from '../otp/otp.component';
import { DialogService } from 'primeng/api';
import { UpdatecontactComponent } from '../updatecontact/updatecontact.component';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'app-trackapp',
  templateUrl: './trackapp.component.html',
  styleUrls: ['./trackapp.component.css'],
  providers: [DialogService]
})
export class TrackappComponent implements OnInit {
  // mobile: RegExp = /[0-9]{10}$/;
  mobile: RegExp = /^[0-9]*$/;
  infoTrack: FormGroup;
  trackList: Object[] = [];
  applicationList: boolean = false;
  isPhoneNumberVerified: boolean = false;
  isFormContorsValid: boolean = false;
  verifiedPhoneNumber: boolean = false;
  membershipId: any = null;
  phoneno: number;
  searchText:number;
  isApplicationSearch:boolean = false;
  isMembershipSearch:boolean = true;
  generateOTP:boolean = false;
  @ViewChild("otpComp") private otpComp: OtpComponent;
  membershipNbr: string;
  cardHolderNbr: string;
  map = new Map<string, string>();
  storeContactNo: string = null;
  
  populateForm: any = {};
  show: boolean = false;
  placeholder: any = 'Application / 17 Digit Membership Number';
  storeList: any =[];
  selectedStore:string;

  constructor(private router: Router,
    private newMemberService: NewmemberService,
    private memberListService: MemberListService,
    private fb: FormBuilder,
    public dialogService: DialogService,
    public store: StoreService,
    private messageService: MessageService, private us: UserService) {
  }

  ngOnInit() {
 
    localStorage.setItem('userPrefLang', 'en');
    this.us.getUserContent().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        localStorage.setItem("token", res.response);
        localStorage.setItem("currDate", res.responseDateTime);
              }
    });

    localStorage.removeItem('ma');
    localStorage.removeItem('mem');
    localStorage.removeItem('status');
    this.createForm();
    localStorage.setItem('cardholderNbr',null);
    this.map.set('AMRITSAR', '+91-7888529898  /  +91-9814316216');
    this.map.set('ZIRAKPUR', '+91-9876529626  /  +91-6280038942');
    this.map.set('JALANDHARu', '+91-6280564887  /  +91-8727884045');
    this.map.set('LUDHIANA (JALANDHAR BYPASS ROAD)', '+91-9781427903  /  +91-9814536181');
    this.map.set('BATHINDA', '+91-7508106968  /  +91-9417369894');
    this.map.set('LUDHIANA (CHANDIGARH ROAD)', '+91-7837743264  /  +91-8054586763');
    this.map.set('BHOPAL (KAROND)', '+91-7303591607  /  +91-8435549867');
    this.map.set('KOTA', '+91-8448791569  /  +91-9829033742');
    this.map.set('RAIPUR', '+91-8319300090  /  +91-8770460678');
    this.map.set('INDORE (DEWAS BYPASS ROAD)', '+91-7303394361  /  +91- 9589350728');
    this.map.set('INDORE (AB ROAD)', '+91-8120003535  /  +91-9575732857');
    this.map.set('BHOPAL (MISROD)', '+91-9870197964  /  +91-9685922970');
    this.map.set('AURANGABAD', '+91-7768888667  /  +91-8149944445');
    this.map.set('AMRAVATI', '+91-8208197225  /  +91-8999582293');
    this.map.set('GUNTUR', '+91-9205695328  /  +91-9704061774');
    this.map.set('HYDERABAD', '+91-8448192021  /  +91-8448380660');
    this.map.set('RAJAHMUNDRY', '+91-9160341645');
    this.map.set('VISHAKHAPATNAM', '+91-8179153952  /  +91-7386132144');
    this.map.set('KARIMNAGAR', '+91-8374685185  /  +91-9573256958');
    this.map.set('VIJAYAWADA', '+91-9205695286  /  +91-8978890050');
    this.map.set('NIZAMABAD', '+91-8897222434  /  +91-8501001982');
    this.map.set('WARANGAL', '+91-9182601353  /  +91-9381763131');
    this.map.set('KURNOOL', '+91-8096864783  /  +91-7989355671');
    this.map.set('MEERUT', '+91-8171011147  /  +91-9760690800');
    this.map.set('JAMMU', '+91-8448394476  /  +91-9682333852');
    this.map.set('AGRA (CHALESAR ROAD)', '+91-8929856465  /  +91-8077915641');
    this.map.set('LUCKNOW', '+91-9140527107  /  +91-8081270237');
    this.map.set('AGRA (SIKANDRA)', '+91-6397757087  /  +91-9811739745');
    
    this.map.forEach((value: string, key: string) => {
      this.storeList.push(key);
    });
    this.storeList.sort();
  }
    

  storeSelection() {
    this.storeContactNo = this.map.get(this.selectedStore);
  }

  track(phone) {
    if (this.infoTrack.valid) {
      this.newMemberService.getExsisting(phone).subscribe((res: any) => {
        if (res.code === 'SUCCESS') {
          this.trackList = res.response;
          this.membershipNbr = null;
          this.cardHolderNbr = null;
          this.applicationList = true;          
        }
      });
    }
  }

  saveTrack(ma, mem, status) {
    localStorage.setItem('ma', ma);
    localStorage.setItem('mem', mem);
    localStorage.setItem('status', status);
    this.generateOTP = true;
  }

  contactInfo() {
    const otpInfo = {
      maMembershipId: localStorage.getItem('ma') != undefined && localStorage.getItem('ma') != null ? localStorage.getItem('ma') : null,
      membershipNbr:  this.membershipNbr != undefined && this.membershipNbr != null ? parseInt(this.membershipNbr) : null,
      phoneNbr: this.phoneno,
      cardHolderNbr: this.cardHolderNbr != undefined && this.cardHolderNbr != null ? parseInt(this.cardHolderNbr) : null,
      category: 'ENABLE_EDIT_OTP_FKW',
      apiType: 'MEMBER_VERIFY',
    };

    return otpInfo;
  }

  updateContact() {
    this.newMemberService.formFill().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        let data: any = {};
        data.populate = res.response;
        const ref = this.dialogService.open(UpdatecontactComponent, {
          data: data,
          header: 'Change Mobile Number',
          styleClass: 'cardOverFlowFix modal-md',
          height: '80%',
          closeOnEscape: false
        });
        ref.onClose.subscribe((status: any) => {
          
        });
      }
    });
    }


  trackGO() {
    if (localStorage.getItem('status') === 'DRAFT') {
      this.router.navigate(['addmember/new', localStorage.getItem('ma')]);
    } else if (localStorage.getItem('status') === 'QC PENDING') {
      this.router.navigate(['/viewmember/qc/', localStorage.getItem('ma')]);
    } else if (localStorage.getItem('status') === 'ONHOLD') {
      this.router.navigate(['/onhold', localStorage.getItem('ma')]);
    } else {

      if (this.membershipNbr != null) {
        this.router.navigate(['/viewmember/', this.membershipNbr]);
      } else {
        this.router.navigate(['/viewmember/qc/', localStorage.getItem('ma')]);
      }
    }

  }

  new() {
    this.router.navigate(['/addmember/new']);
  }

  createForm() {
    this.infoTrack = this.fb.group({
      searchText: new FormControl('', [
        Validators.pattern('^[0-9]*$'),
        // Validators.minLength(10)
      ]),
      membershipNumber: new FormControl('', [
        Validators.pattern('^[0-9]*$'),
        // Validators.minLength(5)
      ])
    });

    this.verifiedPhoneNumber = this.infoTrack.get('searchText').value;
    this.membershipId = this.infoTrack.get('membershipNumber').value;

    this.infoTrack.get('searchText').valueChanges.subscribe(
      (validateBy: any) => {
          if (!this.isMembershipSearch) {
            if (this.infoTrack.get('searchText').value && this.infoTrack.get('searchText').value.length >= 10) {
              this.verifiedPhoneNumber = this.infoTrack.get('searchText').value;
              this.phoneno = this.infoTrack.get('searchText').value;
              this.isFormContorsValid = true;
            } else {
              this.isFormContorsValid = false;
              this.applicationList = false;
            }
        }
      });
  }

  searchEnter() {
    if (this.show) {
      if (this.infoTrack.get('searchText').value && this.infoTrack.get('searchText').value.length >= 10) {
        setTimeout(() => {
          this.otpComp.generateOTP();
        }, 200);
      }
    } else {
      this.getMembershipNbr();
    }
  }

  getMembershipNbr() {
    const membershipSearchValue = this.infoTrack.get('searchText').value;
    if (membershipSearchValue !== undefined) {
    if (membershipSearchValue.length === 17 &&
      membershipSearchValue.length !== 0) {
      // var search = this.infoTrack.get('searchText').value;
      if (membershipSearchValue.indexOf('11734') < 0) {
        this.messageService.add(
          { severity: 'info',
           summary: 'Membership',
           detail: 'Invalid Membership Number, please contact nearest store.'
           });
      } else {
        var membershipNbr = membershipSearchValue.substring(8, membershipSearchValue.length).replace(/^0+/, '');
        this.cardHolderNbr = membershipSearchValue.substring(5, 7);
        localStorage.setItem('cardholderNbr', this.cardHolderNbr);
        this.membershipNbr = membershipNbr;
        this.generateOTP = true;
        localStorage.removeItem('ma');
      }
    } else {
      this.generateOTP = true;
      localStorage.setItem('ma', this.infoTrack.get('searchText').value);
    }
  }
  }

  resetOTP() {
    this.isFormContorsValid = false;
  }

  updateOTPstatus(event) {
    this.isPhoneNumberVerified = event;
    if (event) {    
      this.trackGO();
    } else {
      this.generateOTP = false;
      localStorage.removeItem('ma');
    }
  }

  OTPGenerated(event) {
    if (!event) {
      this.generateOTP = false;
      localStorage.removeItem('ma');
    }

  }

  validatePhoneNumber(): void {
    this.newMemberService.getExsisting(this.verifiedPhoneNumber).subscribe((results: any) => {
        if (results.code === 'SUCCESS') {
          this.trackList = results.response;
          if (this.isApplicationSearch) {
            this.trackGO();
            this.isApplicationSearch = false;
          } else {
            if (this.trackList && this.trackList.length > 0) {
              this.applicationList = true;
            } else {
              this.messageService.add({ severity: 'info', summary: 'Membership', detail: 'Mobile number is not mapped to any membership, Please verify the mobile number.'});  
            }
          }
        }
      });
  }

  onTabChange(event) {
    this.messageService.add({ severity: 'info', summary: 'Tab Expanded', detail: 'Index: ' + event.index });
  }

  inputToggle() {
    localStorage.removeItem('ma');
    localStorage.removeItem('mem');
    localStorage.removeItem('status');
    this.show = !this.show;
    this.searchText = undefined;
    this.generateOTP = false;
    this.applicationList = false;
    this.generateOTP = false;
    this.isMembershipSearch = !this.isMembershipSearch;
    this.resetOTP();
    if (this.show) {
      this.placeholder = 'Phone Number';      
    } else {
      this.placeholder = 'Application / 17 Digit Membership Number';

    }
  }

}
